import { ref, getDownloadURL, getMetadata } from 'firebase/storage';
import { useFirebaseCleanStorage } from '../../../../firebase/useFirebaseStorage';
import { Message } from '../../type';
import _ from 'lodash';
import { useCallback } from 'react';

export type MediaInfo = {
  messageGuid: string;
  fileName: string;
  storageUrl: string;
  thumbnailStorageUrl?: string;
};

export const useStorageInfoFetcher = () => {
  const storage = useFirebaseCleanStorage();
  return useCallback(
    async (messages: Message[]): Promise<Message[]> => {
      const storageInfo = messages
        .filter((message) => !message.mediaDeleted)
        .filter(
          (message) => message.messageType && message.messageType !== 'TEXT',
        )
        .filter(
          (message) => message.scanStatus === 'CLEAN' && !message.compressError,
        )
        .map<Promise<MediaInfo>>(async (message) => {
          const storageRef = ref(storage, message.mediaPath);
          const metadata = await getMetadata(storageRef);
          const storageUrl = await getDownloadURL(storageRef);
          const thumbnailStorageUrl = message.mediaThumbnailPath
            ? await getDownloadURL(ref(storage, message.mediaThumbnailPath))
            : undefined;
          return {
            messageGuid: message.guid,
            fileName: metadata.customMetadata?.name || storageRef.name,
            storageUrl,
            thumbnailStorageUrl,
          };
        });
      const storageInfoByMessageGuid = _.keyBy(
        await Promise.all(storageInfo),
        (info) => info.messageGuid,
      );
      return messages.map((message) => {
        const storageInfo = storageInfoByMessageGuid[message.guid];
        return storageInfo
          ? {
              ...message,
              fileName: storageInfo.fileName,
              url: storageInfo.storageUrl,
              thumbnailUrl: storageInfo.thumbnailStorageUrl,
            }
          : message;
      });
    },
    [storage],
  );
};
